import React, { useCallback } from 'react';
import { IoIosArrowBack } from 'react-icons/io';

import history from '~/services/history';

import IndexPage from './Forms/index';
import { Title, Container } from './styles';

const NewUser: React.FC = () => {
  const handleBackHistory = useCallback(() => {
    history.goBack();
  }, []);

  return (
    <Container>
      <Title onClick={() => handleBackHistory()}>
        <IoIosArrowBack
          style={{ background: '#fff', color: '#EB0045', borderRadius: '50%' }}
          size={16}
        />
        <span>Voltar para usuários</span>
      </Title>
      <div style={{ marginTop: '48px' }}>
        <IndexPage />
      </div>
    </Container>
  );
};

export default NewUser;
